export var ComunEnum = {
    AUTHORIZATION: 'Authorization',
    AUTH_KEY: 'auth_key',
    ID: 'id',
    PAGE: 'page',
    NUMBER_PER_PAGE: 'numberItems',
    FILTER: 'filter'
}

export var DetalleParametrizacionEnum = {
    ROWS_TABLE: 'ROWS_TABLE'
}
